import { IAnnounce } from '../entities/forecast';

/**
 * 内示のファクトリークラス
 */
export class AnnounceFactory {
  /**
   * IAnnounceを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<IAnnounce> = {}): IAnnounce => {
    const announce: Required<IAnnounce> = {
      year: initialData.year ?? 1,
      month: initialData.month ?? 1,
      amount: initialData.amount ?? 0,
      manageInitiatedYearMonth: initialData.manageInitiatedYearMonth,
      createAt: initialData.createAt,
      updateAt: initialData.updateAt,
    };
    return announce;
  };
}
